var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F4F4F4",
    d: "m401.94532,451.59017c-4.01467,0.33486 -7.47125,2.9921 -8.80707,6.80154l-27.41139,77.93504c-0.55809,1.59867 -0.72372,3.30895 -0.46448,4.97963l9.27515,59.1867l200.05667,0.12962l6.65391,-96.66537c0.18723,-2.62124 -0.65171,-5.20287 -2.32239,-7.23001l-42.94798,-51.84507c-2.13876,-2.56363 -5.3901,-3.93906 -8.71346,-3.66181",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m426.40062,599.60013c0.05401,0.29885 -0.11162,0.5941 -0.37086,0.70572",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m424.09983,549.02607l-12.81814,14.51043l9.14553,7.05718l10.72979,-9.79364l-7.05718,-11.77397z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m413.00998,561.1601l-8.17337,6.26505c-0.90015,0.68411 -1.15219,1.94433 -0.6121,2.91649l15.69863,28.98485c0.32405,0.64811 1.08018,0.90015 1.7643,0.64811c1.44024,-0.54009 2.23237,-2.08835 1.8003,-3.5646l-0.18003,-0.68411c-0.90015,-3.16853 -1.36823,-6.40907 -1.40423,-9.72163l-0.21604,-15.30256c0,-0.93616 -0.68411,-1.7643 -1.58427,-1.98033c-2.9885,-0.68411 -5.22087,-3.20454 -5.58093,-6.26505l-0.07201,-0.75613c-0.14402,-0.6121 -0.93616,-0.93616 -1.44024,-0.54009z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m416.97064,556.94739l41.33491,-47.96002l-0.43207,-67.04322l22.64779,0l-3.34856,71.79601c-0.03601,3.06051 -1.29622,5.977 -3.52859,8.10136l-47.92402,43.96335l-8.74946,-8.85748z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m484.878,383.93845l-1.26021,20.45142l-1.65628,-0.25204l-1.47625,37.91434l-48.10405,-0.14402l-0.82814,-42.48711l-4.03267,-25.42025l15.5546,-4.42874l0.54009,-0.14402l1.98033,-0.5761l8.42541,7.23721l8.9655,-7.34523l2.3764,0.75613c0.18003,0.03601 0.25204,0.07201 0.28805,0.07201l0.03601,0c0,0 0,0 0.10802,0.03601l0.10802,0.03601l11.52193,3.67261c4.64478,1.47625 7.66928,5.83298 7.45325,10.62178z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m419.81511,383.54239l-2.80847,39.60663l18.21905,-7.27322l3.96066,-44.64747l-11.23388,2.70045c-4.50075,1.08018 -7.81331,4.96883 -8.13736,9.61361z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m452.72462,377.85343l-3.02451,47.92402l4.10469,4.39273l3.85264,-4.39273l-2.19637,-48.14005l-1.44024,-0.97216l-1.29622,1.1882z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m519.65982,380.30184l-26.14037,41.11888c-1.94433,3.06051 -6.51709,2.62844 -7.88532,-0.72012l-6.91316,-17.24689l5.43691,-23.79998l7.92133,22.32373l15.12253,-21.67563l12.45808,0l0,0z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m431.87713,578.479l11.77397,0.25204l-0.5761,9.10952l-10.87382,0.97216l-0.32405,-10.33373z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m437.6381,583.2678c3.13252,0 5.72496,2.48442 5.83298,5.61694l0.03601,1.44024c0.03601,0.5761 0.10802,1.15219 0.25204,1.69228l1.62027,5.977c0.28805,1.04417 -0.50408,2.05234 -1.54826,2.05234l-13.39424,0c-1.15219,0 -1.94433,-1.15219 -1.51225,-2.23237l2.30439,-5.76096c0.32405,-0.79213 0.50408,-1.65628 0.54009,-2.52042l0.03601,-0.68411c0.10802,-3.06051 2.66445,-5.58093 5.83298,-5.58093z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m481.70947,410.79895l-5.22087,-12.31406c-0.28805,-0.39607 -0.93616,-0.25204 -0.97216,0.25204l-2.73646,43.17122l7.70529,0.14402l1.2242,-31.25323z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m472.77997,441.94416l-4.28472,72.04805l-37.0862,39.89467l-0.10802,-10.7658l-1.94433,2.30439l-0.75613,11.48592l-5.65295,6.08502l2.77246,2.80847l48.10405,-44.14338c2.12436,-2.01634 3.34856,-4.7888 3.34856,-7.70529l3.34856,-72.01205l-7.74129,0l0,0z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.2,
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m451.48601,515.79611l-1.48705,27.14494l0.54009,0.0288l1.48705,-27.14494l-0.54009,-0.0288z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m465.1827,406.62225l2.19637,-3.24054l0.54009,-3.45658c0.03601,-0.14402 0.14402,-0.25204 0.28805,-0.28805c0.97216,-0.21604 1.90832,0.43207 2.05234,1.40423l0.68411,4.1767l7.66928,-0.54009c0.5761,0 1.08018,0.43207 1.15219,1.00817c0.07201,0.64811 -0.46808,1.2242 -1.11619,1.2242l-0.6121,0l0.64811,0c0.64811,0 1.2242,0.50408 1.26021,1.15219c0.07201,0.68411 -0.43207,1.33222 -1.15219,1.36823l-0.5761,0.03601l0.64811,-0.07201c0.64811,-0.07201 1.2242,0.43207 1.29622,1.08018c0.07201,0.64811 -0.43207,1.2242 -1.08018,1.29622l-0.75613,0.07201l1.08018,-0.10802c0.46808,-0.03601 0.90015,0.32405 0.97216,0.79213c0.03601,0.46808 -0.28805,0.86414 -0.72012,0.93616l-13.39424,2.16036l-5.25688,1.54826l1.40423,-10.33373l2.77246,-0.21604z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m439.18635,408.99864c-2.30439,-1.2242 -3.85264,-3.52859 -4.10469,-6.12102l-1.08018,-11.08986c-0.03601,-0.25204 -0.36006,-0.25204 -0.39607,0l-1.8003,18.07502l-4.06868,0.46808c-0.14402,0 -0.25204,0.14402 -0.21604,0.28805c0,0.14402 0.14402,0.25204 0.28805,0.21604l37.41026,-4.24871l0.43207,-0.64811l-26.46443,3.06051z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m480.37725,412.56324l-0.03601,-0.07201c-0.10802,-0.50408 -0.6121,-0.82814 -1.08018,-0.72012l-0.14402,0.03601l-11.12586,1.69228l-2.9885,-6.87715l-0.82814,0l-3.09652,0.36006l0.93616,9.97367c0,0 5.22087,-1.40423 5.4009,-1.44024l0.97216,-0.14402c3.45658,-0.5761 10.40574,-1.69228 11.12586,-1.8003c1.00817,-0.21604 0.86414,-1.00817 0.86414,-1.00817z",
    className: "st8"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m475.3364,406.91029c0,-0.14402 0.10802,-0.25204 0.25204,-0.25204l4.03267,-0.32405c-0.18003,0.36006 -0.54009,0.6121 -0.93616,0.6121l-0.03601,0l-3.02451,0.25204c-0.14402,-0.03601 -0.28805,-0.14402 -0.28805,-0.28805z",
    className: "st8"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m475.51643,409.61075c0,-0.14402 0.07201,-0.25204 0.21604,-0.28805l4.06868,-0.54009c-0.14402,0.36006 -0.50408,0.6121 -0.90015,0.64811l-0.03601,0l-3.09652,0.43207c-0.10802,0 -0.21604,-0.10802 -0.25204,-0.25204z",
    className: "st8"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m458.5936,379.79776l-0.07201,-0.07201l0.07201,0.07201l-4.39273,-1.1882l-4.2127,1.2242l-6.91316,-10.22571l0.54009,-0.14402l6.80514,10.04568l3.63661,-2.84448l4.10469,2.84448l7.27322,-9.97367c0.18003,0.03601 0.25204,0.07201 0.28805,0.07201l0.03601,0c0,0 0,0 0.10802,0.03601l0.10802,0.03601l-7.38123,10.11769z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m418.26686,412.23919l44.14338,-5.3649l1.51225,9.43358l-41.839,12.20604c-2.77246,0.82814 -5.50892,-1.47625 -5.18487,-4.35673l1.36823,-11.91799z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m463.67045,414.6876l-39.53461,9.46958c-3.52859,0.75613 -6.84114,-2.08835 -6.5531,-5.72496l0.07201,-0.79213l-0.72012,6.51709c-0.32405,2.88048 2.4124,5.18487 5.18487,4.35673l16.77881,-4.93283l25.06019,-7.30922l-0.28805,-1.58427z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m463.09435,406.83828l1.83631,9.25355l1.8003,-0.43207l-1.72829,-9.03751l-1.90832,0.21604z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m465.00267,413.42738c1.13419,0 2.05234,-0.91815 2.05234,-2.05234c0,-1.13419 -0.91815,-2.05234 -2.05234,-2.05234c-1.13419,0 -2.05234,0.91815 -2.05234,2.05234c0,1.13059 0.92175,2.05234 2.05234,2.05234z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m466.29889,413.42738l-0.86414,-4.42874c-0.14402,-0.03601 -0.28805,-0.03601 -0.46808,-0.03601c-0.54009,0 -1.00817,0.18003 -1.40423,0.46808l0.86414,4.35673c0.18003,0.03601 0.36006,0.07201 0.54009,0.07201c0.50408,-0.07201 0.97216,-0.21604 1.33222,-0.43207z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m465.00267,413.17534c0.99377,0 1.8003,-0.80653 1.8003,-1.8003c0,-0.99377 -0.80653,-1.8003 -1.8003,-1.8003c-0.99377,0 -1.8003,0.80653 -1.8003,1.8003c0,0.99377 0.80653,1.8003 1.8003,1.8003z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m432.38122,441.94416l-0.68411,140.74754l11.88199,0l11.70196,-116.91156c0.03601,-0.68411 0.5761,-1.1882 1.26021,-1.1882c0.68411,0 1.2242,0.54009 1.26021,1.1882l0.32405,10.80181l1.83631,-34.63779l-27.58061,0z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m456.50525,464.55594c-7.12919,0 -13.35823,5.79697 -13.35823,12.92616l-4.64478,105.17359l5.00484,0l11.70196,-116.91156c0.07201,-0.64811 0.64811,-1.1882 1.29622,-1.1882z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m480.34124,446.22887l-47.99603,0l0.03601,-4.28472l48.14005,0l-0.18003,4.28472z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m445.70345,441.94416l-1.54826,0l0,4.64478l1.54826,0l0,-4.64478z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m466.51493,441.94416l-1.54826,0l0,4.64478l1.54826,0l0,-4.64478z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m459.2057,446.22887l-5.65295,0c-0.5761,0 -1.04417,-0.46808 -1.04417,-1.04417l0,-2.19637c0,-0.5761 0.46808,-1.04417 1.04417,-1.04417l5.65295,0c0.5761,0 1.04417,0.46808 1.04417,1.04417l0,2.19637c0,0.5761 -0.46808,1.04417 -1.04417,1.04417z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m435.15368,589.20879c-0.07201,0 -0.18003,-0.03601 -0.21604,-0.10802c-0.07201,-0.10802 -0.03601,-0.28805 0.07201,-0.36006c0.03601,0 2.62844,-1.72829 5.18487,0c0.10802,0.07201 0.14402,0.25204 0.07201,0.36006c-0.07201,0.10802 -0.25204,0.14402 -0.36006,0.07201c-2.26838,-1.51225 -4.57276,0 -4.60877,0c-0.03601,0.03601 -0.10802,0.03601 -0.14402,0.03601z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m435.15368,590.75705c-0.07201,0 -0.18003,-0.03601 -0.21604,-0.10802c-0.07201,-0.10802 -0.03601,-0.28805 0.07201,-0.36006c0.03601,0 2.62844,-1.72829 5.18487,0c0.10802,0.07201 0.14402,0.25204 0.07201,0.36006c-0.07201,0.10802 -0.25204,0.14402 -0.36006,0.07201c-2.26838,-1.51225 -4.57276,0 -4.60877,0c-0.03601,0 -0.10802,0.03601 -0.14402,0.03601z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m435.15368,592.2693c-0.07201,0 -0.18003,-0.03601 -0.21604,-0.10802c-0.07201,-0.10802 -0.03601,-0.28805 0.07201,-0.36006c0.03601,0 2.62844,-1.72829 5.18487,0c0.10802,0.07201 0.14402,0.25204 0.07201,0.36006c-0.07201,0.10802 -0.25204,0.14402 -0.36006,0.07201c-2.26838,-1.51225 -4.57276,0 -4.60877,0c-0.03601,0.03601 -0.10802,0.03601 -0.14402,0.03601z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m418.91496,574.59034c-0.14402,0 -0.25204,-0.10802 -0.25204,-0.21604c-0.03601,-0.14402 0.07201,-0.28805 0.21604,-0.28805l2.77246,-0.39607c0.14402,-0.03601 0.28805,0.07201 0.28805,0.21604c0.03601,0.14402 -0.07201,0.28805 -0.21604,0.28805l-2.80847,0.39607z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m418.95097,576.46266c-0.14402,0 -0.25204,-0.10802 -0.25204,-0.21604c-0.03601,-0.14402 0.07201,-0.28805 0.21604,-0.28805l2.77246,-0.39607c0.14402,-0.03601 0.28805,0.07201 0.28805,0.21604c0.03601,0.14402 -0.07201,0.28805 -0.21604,0.28805l-2.80847,0.39607c0.03601,0 0.03601,0 0,0z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m418.95097,578.55101c-0.14402,0 -0.25204,-0.10802 -0.25204,-0.21604c-0.03601,-0.14402 0.07201,-0.28805 0.21604,-0.28805l2.77246,-0.39607c0.14402,-0.03601 0.28805,0.07201 0.28805,0.21604c0.03601,0.14402 -0.07201,0.28805 -0.21604,0.28805l-2.80847,0.39607c0.03601,0 0.03601,0 0,0z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.2,
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m432.3092,458.54293l3.70862,-12.42208c0.03601,-0.14402 0.18003,-0.21604 0.32405,-0.18003c0.14402,0.03601 0.21604,0.18003 0.18003,0.32405l-4.2127,14.15037l0,-1.87231z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.2,
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m479.72914,458.79497l-3.78063,-12.67412c-0.03601,-0.14402 -0.18003,-0.21604 -0.32405,-0.18003c-0.14402,0.03601 -0.21604,0.18003 -0.18003,0.32405l4.2127,14.15037l0.07201,-1.62027z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.2,
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m458.16153,509.81551c-0.07201,0 -0.10802,-0.03601 -0.18003,-0.07201c-0.10802,-0.10802 -0.10802,-0.25204 -0.03601,-0.36006l4.7888,-5.58093c0.10802,-0.10802 0.25204,-0.10802 0.36006,-0.03601c0.10802,0.10802 0.10802,0.25204 0.03601,0.36006l-4.7888,5.58093c0,0.07201 -0.07201,0.10802 -0.18003,0.10802z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m490.45893,403.99381l1.62027,-2.01634l-1.98033,-5.58093l-1.11619,6.98517c-0.07201,0.68411 1.04417,1.15219 1.47625,0.6121z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m492.33125,422.64493c0.82814,-0.54009 1.26021,-1.29622 1.98033,-2.52042l1.44024,-2.23237l0,-21.02752l-3.42057,25.78031z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m454.02084,376.66524l9.03751,-7.92133l-1.33222,-17.931l-14.97851,0l-1.11619,18.07502l8.3894,7.7773z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m463.74246,344.51186c0,0 1.87231,20.52343 -9.39757,20.66746c-11.01784,0.14402 -10.11769,-20.41542 -10.11769,-20.41542l0.03601,-5.90499l14.25839,-1.65628l3.45658,2.05234l1.7643,5.25688z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m461.36607,339.75906c0,0 3.70862,-2.16036 5.14886,1.98033c1.2242,3.49258 -1.40423,7.09319 -1.40423,7.09319l-2.05234,-0.32405c-0.86414,-0.07201 -1.44024,-0.50408 -1.47625,-1.36823l-0.21604,-7.38123z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m464.06652,337.45468c0.07201,3.88865 -3.31255,4.71679 -4.64478,4.7528l-11.16187,0.28805c-0.90015,0.03601 -1.62027,0.75613 -1.62027,1.65628l0,3.52859c0,0.46808 -0.36006,0.90015 -0.86414,0.93616l-0.68411,0.03601l-0.82814,0.90015c-4.28472,-1.29622 -5.3649,-13.7543 2.77246,-15.77064c0.86414,-0.21604 1.65628,-0.79213 2.08835,-1.58427c1.29622,-2.34039 6.12102,-2.70045 8.3534,0.14402c0.46808,0.6121 1.08018,0.90015 1.83631,0.93616c2.95249,0.10802 4.71679,2.05234 4.7528,4.1767z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m445.01933,349.87675c-0.07201,-1.44024 -1.72829,-2.26838 -2.88048,-1.44024l-0.03601,0.03601c-2.01634,1.54826 -1.08018,6.80514 3.13252,6.5891l-0.21604,-5.18487z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m466.11886,348.3645l-0.03601,-0.03601c-1.1882,-0.82814 -2.80847,0.03601 -2.84448,1.47625l-0.07201,4.96883c4.24871,0.10802 4.96883,-4.93283 2.95249,-6.40907z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m445.52341,350.56087c0,0.25204 -0.21604,0.46808 -0.50408,0.46808c-0.28805,0 -0.50408,-0.18003 -0.54009,-0.39607l-0.28805,-3.34856l1.36823,0.14402l-0.03601,3.13252z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m464.10252,350.27282c0,0.25204 -0.21604,0.46808 -0.50408,0.46808c-0.28805,0 -0.50408,-0.18003 -0.54009,-0.39607l-0.28805,-3.34856l1.36823,0.14402l-0.03601,3.13252z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m459.42174,342.71156c-0.32405,0 -0.54009,-0.03601 -0.5761,-0.03601c-0.14402,0 -0.21604,-0.14402 -0.21604,-0.25204c0,-0.14402 0.14402,-0.21604 0.25204,-0.21604c0.03601,0 2.23237,0.25204 3.27655,-1.1882c0.07201,-0.10802 0.21604,-0.14402 0.32405,-0.03601c0.10802,0.07201 0.14402,0.21604 0.03601,0.32405c-0.79213,1.1882 -2.26838,1.40423 -3.09652,1.40423z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m450.52825,353.08129c0.53649,0 0.97216,-0.43567 0.97216,-0.97216c0,-0.53649 -0.43567,-0.97216 -0.97216,-0.97216s-0.97216,0.43567 -0.97216,0.97216c0,0.53649 0.43567,0.97216 0.97216,0.97216z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m450.06017,352.21715c0.11882,0 0.21604,-0.09722 0.21604,-0.21604c0,-0.11882 -0.09722,-0.21604 -0.21604,-0.21604c-0.11882,0 -0.21604,0.09722 -0.21604,0.21604c0,0.11882 0.09722,0.21604 0.21604,0.21604z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m458.05351,352.97327c0.53649,0 0.97216,-0.43567 0.97216,-0.97216s-0.43567,-0.97216 -0.97216,-0.97216s-0.97216,0.43567 -0.97216,0.97216s0.43567,0.97216 0.97216,0.97216z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m457.58543,352.10913c0.11882,0 0.21604,-0.09722 0.21604,-0.21604c0,-0.11882 -0.09722,-0.21604 -0.21604,-0.21604c-0.11882,0 -0.21604,0.09722 -0.21604,0.21604c0,0.11882 0.09722,0.21604 0.21604,0.21604z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m454.48891,356.96994l0.79213,0c0.14402,0 0.28805,-0.14402 0.28805,-0.28805s-0.14402,-0.28805 -0.28805,-0.28805l-0.79213,0c-0.32405,0 -0.5761,-0.25204 -0.5761,-0.5761s0.25204,-0.6121 0.5761,-0.6121c0.14402,0 0.28805,-0.14402 0.28805,-0.28805s-0.14402,-0.28805 -0.28805,-0.28805c-0.64811,0 -1.15219,0.54009 -1.15219,1.15219c0,0.68411 0.50408,1.2242 1.15219,1.1882z",
    className: "st14"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m460.93399,349.5527l-4.24871,0l-0.5761,0l-3.70862,0l-0.03601,0l-4.7888,0c-0.79213,0 -1.40423,0.6121 -1.40423,1.40423l0,1.08018c0,2.08835 1.69228,3.81664 3.81664,3.81664c2.08835,0 3.81664,-1.69228 3.81664,-3.81664l0,-1.08018c0,-0.32405 -0.10802,-0.6121 -0.28805,-0.86414l1.47625,0c-0.18003,0.25204 -0.28805,0.54009 -0.28805,0.82814l0,1.08018c0,2.08835 1.69228,3.81664 3.81664,3.81664c2.08835,0 3.81664,-1.69228 3.81664,-3.81664l0,-1.08018c0,-0.72012 -0.6121,-1.36823 -1.40423,-1.36823zm-7.70529,1.40423l0,1.08018c0,1.8003 -1.47625,3.24054 -3.27655,3.24054s-3.24054,-1.47625 -3.24054,-3.27655l0,-1.08018c0,-0.46808 0.39607,-0.82814 0.86414,-0.82814l4.7888,0l0.03601,0c0.46808,0 0.86414,0.39607 0.82814,0.86414zm8.53343,1.08018c0,1.8003 -1.47625,3.24054 -3.27655,3.24054s-3.24054,-1.47625 -3.24054,-3.27655l0,-1.08018c0,-0.46808 0.39607,-0.82814 0.86414,-0.82814l0.5761,0l4.24871,0c0.46808,0 0.82814,0.39607 0.82814,0.86414l0,1.08018z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m452.0045,358.37418l4.7888,-0.07201c0.10802,0 0.21604,0.10802 0.18003,0.25204c-0.82814,2.4124 -4.1767,2.48442 -5.11286,0.10802l0,-0.03601c-0.07201,-0.10802 0.03601,-0.25204 0.14402,-0.25204z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m443.79513,352.50519c-0.14402,0 -0.28805,-0.10802 -0.28805,-0.25204l-0.03601,-0.6121c-0.03601,-0.64811 -0.18003,-1.08018 -0.46808,-1.33222c-0.21604,-0.18003 -0.43207,-0.18003 -0.46808,-0.18003c-0.14402,0 -0.28805,-0.10802 -0.28805,-0.25204s0.10802,-0.28805 0.25204,-0.32405c0.03601,0 0.46808,-0.03601 0.86414,0.28805c0.39607,0.32405 0.6121,0.93616 0.64811,1.72829l0.03601,0.6121c0.03601,0.18003 -0.07201,0.28805 -0.25204,0.32405c0.03601,0 0.03601,0 0,0z",
    className: "st14"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m464.5706,352.21715c0.14402,0 0.28805,-0.10802 0.28805,-0.25204l0.03601,-0.6121c0,-0.64811 0.14402,-1.11619 0.39607,-1.33222c0.21604,-0.21604 0.43207,-0.18003 0.43207,-0.18003c0.14402,0 0.28805,-0.10802 0.28805,-0.25204c0,-0.14402 -0.10802,-0.28805 -0.25204,-0.28805c-0.03601,0 -0.46808,-0.03601 -0.86414,0.32405s-0.6121,0.93616 -0.6121,1.7643l-0.03601,0.6121c0.03601,0.07201 0.14402,0.18003 0.32405,0.21604z",
    className: "st14"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m462.30222,358.55421l0.03601,-0.10802c-1.2242,3.49258 -3.52859,6.30105 -7.2012,6.69712l0.03601,0c-0.25204,0.03601 -0.54009,0.03601 -0.79213,0.03601c-2.95249,0.03601 -5.29289,-1.47625 -6.94916,-4.46475c-0.07201,-0.10802 -0.21604,-0.18003 -0.36006,-0.10802c-0.10802,0.07201 -0.18003,0.21604 -0.10802,0.36006c1.7643,3.16853 4.24871,4.7528 7.41724,4.71679c0.68411,0 1.33222,-0.10802 1.94433,-0.25204c1.94433,0.39607 4.1767,0.03601 6.37307,-1.36823l-0.39607,-5.50892z",
    className: "st8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.8,
    d: "m404.1885,570.34163l15.69863,28.98485c0.32405,0.64811 1.08018,0.90015 1.7643,0.64811c0.14402,-0.03601 0.28805,-0.10802 0.39607,-0.18003l-17.24689,-32.40542c-0.90015,0.72012 -1.15219,1.94433 -0.6121,2.95249z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.8,
    d: "m430.43689,600.08261l13.39424,0c1.04417,0 1.8003,-0.97216 1.58427,-1.98033l-16.56277,0c-0.21604,1.00817 0.54009,1.98033 1.58427,1.98033z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    d: "m465.07469,411.80711l-1.11619,-0.36006l0.03601,-0.18003l0.97216,0.32405l0.68411,-1.15219l0.18003,0.10802l-0.75613,1.26021z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m713.80429,479.82249l0,4.10469",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m714.30838,600.33465l-209.91512,0c-2.84448,0 -5.11286,-2.30439 -5.11286,-5.11286l0,-209.91512c0,-2.84448 2.30439,-5.11286 5.11286,-5.11286l209.91512,0c2.84448,0 5.11286,2.30439 5.11286,5.11286l0,209.91512c0,2.84448 -2.26838,5.11286 -5.11286,5.11286z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.5,
    d: "m714.30838,600.33465l-209.91512,0c-2.84448,0 -5.11286,-2.30439 -5.11286,-5.11286l0,-209.91512c0,-2.84448 2.30439,-5.11286 5.11286,-5.11286l209.91512,0c2.84448,0 5.11286,2.30439 5.11286,5.11286l0,209.91512c0,2.84448 -2.26838,5.11286 -5.11286,5.11286z",
    className: "st17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m710.77979,600.33465l-209.91512,0c-2.84448,0 -5.11286,-2.30439 -5.11286,-5.11286l0,-209.91512c0,-2.84448 2.30439,-5.11286 5.11286,-5.11286l209.91512,0c2.84448,0 5.11286,2.30439 5.11286,5.11286l0,209.91512c0,2.84448 -2.26838,5.11286 -5.11286,5.11286z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.7,
    d: "m710.77979,600.33465l-209.91512,0c-2.84448,0 -5.11286,-2.30439 -5.11286,-5.11286l0,-209.91512c0,-2.84448 2.30439,-5.11286 5.11286,-5.11286l209.91512,0c2.84448,0 5.11286,2.30439 5.11286,5.11286l0,209.91512c0,2.84448 -2.26838,5.11286 -5.11286,5.11286z",
    className: "st18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m507.70582,378.42953c0,0.97216 0.79213,1.72829 1.72829,1.72829l2.3764,0l0.5761,5.76096c0.03601,0.43207 0.43207,0.79213 0.86414,0.79213c0.46808,0 0.82814,-0.36006 0.86414,-0.82814l0.36006,-5.50892c0,-0.07201 0.07201,-0.14402 0.18003,-0.14402c0.07201,0 0.14402,0.07201 0.18003,0.14402l0.36006,5.43691c0.03601,0.50408 0.43207,0.90015 0.93616,0.90015c0.50408,0 0.93616,-0.39607 0.93616,-0.93616l0.18003,-5.50892l-0.18003,5.3649c-0.03601,0.5761 0.46808,1.08018 1.04417,1.08018c0.54009,0 0.97216,-0.39607 1.04417,-0.93616l0.50408,-5.47292l-0.36006,4.06868c-0.03601,0.50408 0.36006,0.97216 0.86414,0.97216c0.43207,0 0.79213,-0.28805 0.86414,-0.72012l0.68411,-3.45658c0.18003,-0.90015 -0.14402,-1.83631 -0.82814,-2.4124c-2.77246,-2.4124 -6.73313,-2.88048 -9.97367,-1.11619l-3.06051,0.6121c-0.07201,-0.03601 -0.14402,0.07201 -0.14402,0.18003z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m517.02778,380.27304l-0.16923,5.07325l0.50408,0.018l0.16923,-5.07325l-0.50408,-0.018z",
    className: "st8"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m519.36817,380.58989l-0.34206,4.09028l0.50048,0.04321l0.34206,-4.09028l-0.50048,-0.04321z",
    className: "st8"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m511.8105,380.19383l-2.3764,0l1.44024,-1.36823c0.28805,-0.28805 0.79213,-0.10802 0.82814,0.32405l0.10802,1.04417z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m685.70159,567.31713l-152.15425,0c-3.24774,0 -5.80057,-2.62844 -5.80057,-5.80057l0,-152.15425c0,-3.24774 2.62844,-5.80057 5.80057,-5.80057l152.15425,0c3.24774,0 5.80057,2.62844 5.80057,5.80057l0,152.15425c0,3.24774 -2.55283,5.80057 -5.80057,5.80057z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.5,
    d: "m685.70159,567.31713l-152.15425,0c-3.24774,0 -5.80057,-2.62844 -5.80057,-5.80057l0,-152.15425c0,-3.24774 2.62844,-5.80057 5.80057,-5.80057l152.15425,0c3.24774,0 5.80057,2.62844 5.80057,5.80057l0,152.15425c0,3.24774 -2.55283,5.80057 -5.80057,5.80057z",
    className: "st17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m678.11872,567.31713l-152.15065,0c-3.24774,0 -5.80057,-2.62844 -5.80057,-5.80057l0,-152.15425c0,-3.24774 2.62844,-5.80057 5.80057,-5.80057l152.15425,0c3.24774,0 5.80057,2.62844 5.80057,5.80057l0,152.15425c0.07561,3.24774 -2.55283,5.80057 -5.80417,5.80057z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656D",
    d: "m637.8964,515.56927l-71.62678,0c-2.55283,0 -4.56556,-2.08835 -4.56556,-4.56556c0,-2.55283 2.08835,-4.56556 4.56556,-4.56556l71.63038,0c2.55283,0 4.56556,2.08835 4.56556,4.56556c-0.0036,2.55283 -2.01634,4.56556 -4.56916,4.56556z",
    className: "st19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m656.54031,533.43546l-108.91462,0c-1.31422,0 -2.398,-1.08378 -2.398,-2.398c0,-1.31422 1.08378,-2.398 2.398,-2.398l108.91462,0c1.31422,0 2.398,1.08378 2.398,2.398c0.07561,1.31422 -1.08378,2.398 -2.398,2.398z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m634.56944,548.28794l-64.89726,0c-1.31422,0 -2.398,-1.08378 -2.398,-2.398c0,-1.31422 1.08378,-2.398 2.398,-2.398l64.90086,0c1.31422,0 2.398,1.08378 2.398,2.398c-0.0036,1.31422 -1.08378,2.398 -2.4016,2.398z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m608.27064,422.59092l-6.18944,0l0,0.6193c-14.38801,2.86248 -25.29423,15.62661 -25.29423,30.86436c0,15.23775 10.83061,28.00188 25.29423,30.86436l0,0.6193l6.18944,0c17.40531,0 31.48367,-14.07836 31.48367,-31.48367s-14.07836,-31.48367 -31.48367,-31.48367z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m602.0812,485.47904c17.38731,0 31.48367,-14.09636 31.48367,-31.48367c0,-17.38731 -14.09636,-31.48367 -31.48367,-31.48367c-17.38731,0 -31.48367,14.09636 -31.48367,31.48367c0.0036,17.38731 14.09636,31.48367 31.48367,31.48367z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.4,
    d: "m602.0812,485.47904c17.38731,0 31.48367,-14.09636 31.48367,-31.48367c0,-17.38731 -14.09636,-31.48367 -31.48367,-31.48367c-17.38731,0 -31.48367,14.09636 -31.48367,31.48367c0.0036,17.38731 14.09636,31.48367 31.48367,31.48367z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m596.20502,467.14477l-10.59657,-10.59657c-0.54009,-0.54009 -0.54009,-1.46905 0,-2.08835l2.78327,-2.78327c0.54009,-0.54009 1.46905,-0.54009 2.08835,0l6.80874,6.80874l16.39714,-16.47636c0.54009,-0.54009 1.46905,-0.54009 2.08835,0l2.78327,2.78327c0.54009,0.54009 0.54009,1.46905 0,2.08835l-20.26779,20.26779c-0.54009,0.6157 -1.46905,0.6157 -2.08475,-0.0036z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m782.17973,601.1988l-407.91224,0c-0.25204,0 -0.43207,-0.18003 -0.43207,-0.43207c0,-0.25204 0.18003,-0.43207 0.43207,-0.68411l407.87623,0c0.43207,0.07201 0.43207,0.43207 0.43207,0.68411c0,0.21604 -0.18003,0.43207 -0.39607,0.43207z",
    className: "st16"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.91741fc2ffbad4b263021b1ba173afe5.svg";
export { ForwardRef as ReactComponent };